import React from "react";
import "./MemberActions.css";

import useMemberActions from "./useMemberActions";
import { DownloadIcon, ReloadIcon } from "../../../../../utils/icons";
import ScreenHeader from "../../../../../CommonComponents/ScreenHeader";
import ChantButton from "../../../../../CommonComponents/ChantButton/ChantButton";
import IconContainer from "../../../../../CommonComponents/IconContainer";
// eslint-disable-next-line no-unused-vars
import { PlusOutlined, SyncOutlined } from "@ant-design/icons";
// eslint-disable-next-line no-unused-vars
import { Tooltip } from "antd";
import { isMobile } from "../../../../../utils/helper";
import ChantPopConfirm from "../../../../../CommonComponents/ChantTooltip/ChantPopConfirm";
import useAdminDataStore, {
  selectCurrentGroupData,
} from "../../../../../store/adminData/adminData";
import UserCountBadge from "./MemberCount";
import GroupLock from "./GroupLock";
import usePackages from "../../../../../hooks/usePackages";
import useSyncPenyaNumbers from "../SyncPenyaNumbers/useSyncPenyaNumbers";
import SyncPenyaNumbersModal from "../SyncPenyaNumbers/SyncPenyaNumbersModal";

const MemberActions = ({ tableData, addMemberLoading, handleAddMember }) => {
  const { downloading, handleMemberRefresh, handleDownloadCsv } =
    useMemberActions(tableData);

  const { hasPackages } = usePackages();

  const groupData = useAdminDataStore(selectCurrentGroupData);

  const groupLocked = groupData?.requireMembershipPackage;

  const {
    showInitialWarning,
    handleContinueFromWarning,
    handleCloseWarning,
    isModalOpen,
    // eslint-disable-next-line no-unused-vars
    handleOpen: handleOpenSyncModal,
    handleClose: handleCloseSyncModal,
    allMembersWithNumbers,
    memberBreakdown,
    syncChanges,
    syncing,
    syncingNewMembers,
    showConfirm,
    setShowConfirm,
    handleSync,
  } = useSyncPenyaNumbers();

  return (
    <>
      <ScreenHeader
        title={"Members"}
        iconComponent={
          <div style={{ display: "flex", alignItems: "center", gap: "24px" }}>
            <UserCountBadge count={tableData?.length || 0} />{" "}
            {hasPackages && <GroupLock groupLocked={groupLocked} />}
          </div>
        }
        actions={
          <div className="member-actions-buttons">
            <ChantPopConfirm
              title="Download all members list?"
              onConfirm={handleDownloadCsv}
              onCancel={() => {}}
              okText="Yes"
              cancelText="No"
              trigger="click"
            >
              <IconContainer
                loading={downloading}
                icon={DownloadIcon}
                disabled={downloading || tableData?.length === 0}
              />
            </ChantPopConfirm>

            <ChantPopConfirm
              title="Refresh Member List?"
              onConfirm={handleMemberRefresh}
              onCancel={() => {}}
              okText="Yes"
              cancelText="No"
            >
              <IconContainer
                loading={downloading}
                icon={ReloadIcon}
                disabled={downloading}
              />
            </ChantPopConfirm>

            {/* Sync Group Member Number — hidden for now, re-enable when needed
            <Tooltip title="Sync Group Member Number">
              <IconContainer
                onClick={handleOpenSyncModal}
                iconComponent={<SyncOutlined />}
                iconStyle={{ fontSize: "16px" }}
                disabled={downloading}
              />
            </Tooltip>
            */}

            {isMobile() ? (
              <IconContainer
                onClick={handleAddMember}
                iconComponent={<PlusOutlined />}
                iconStyle={{ fontSize: "16px" }}
                disabled={addMemberLoading || downloading}
              />
            ) : (
              <ChantButton
                onClick={handleAddMember}
                loading={addMemberLoading}
                disabled={addMemberLoading || downloading}
              >
                Add Member
              </ChantButton>
            )}
          </div>
        }
      />

      <SyncPenyaNumbersModal
        showInitialWarning={showInitialWarning}
        onContinueFromWarning={handleContinueFromWarning}
        onCloseWarning={handleCloseWarning}
        isOpen={isModalOpen}
        onClose={handleCloseSyncModal}
        allMembersWithNumbers={allMembersWithNumbers}
        memberBreakdown={memberBreakdown}
        syncChanges={syncChanges}
        syncing={syncing}
        syncingNewMembers={syncingNewMembers}
        showConfirm={showConfirm}
        setShowConfirm={setShowConfirm}
        handleSync={handleSync}
      />
    </>
  );
};

export default MemberActions;
